import React from 'react';

import type {
    GetEditionEngagementStats_edition_engagementStats as EngagementStats,
    GetEditionEngagementStats_edition_comparison as Comparison,
} from 'nutshell-graphql-types';

import {PercentageText} from './percentage-text';
import {ResultsBannerContainer} from './results/results-banner-container';

type Props = {
    comparison: Comparison;
    versionAId: string;
    isLoading: boolean;
    versionAStats: EngagementStats;
    versionBStats: EngagementStats;
};

function getHeaderText(hasWinner: boolean, versionAIsWinning: boolean, isTied: boolean) {
    if (!hasWinner) {
        if (isTied) {
            return 'Your A/B test is currently tied';
        }

        return versionAIsWinning
            ? 'Version A is winning your A/B test'
            : 'Version B is winning your A/B test';
    }

    return versionAIsWinning ? 'Version A won your A/B test' : 'Version B won your A/B test';
}

export function ComparisonTestResultsBanner(props: Props) {
    if (props.versionAStats.totalSentCount === 0) {
        return (
            <ResultsBannerContainer
                isLoading={props.isLoading}
                headerText='Kicking off your test…'
                subheaderText='Check back later or stay on this page for up-to-date results!'
            />
        );
    }

    const hasWinner = Boolean(props.comparison.winnerEdition);
    const versionAIsWinning = props.comparison.winningEdition
        ? props.comparison.winningEdition.id === props.versionAId
        : false;

    const isTied = props.comparison.isTied;

    return (
        <ResultsBannerContainer
            isLoading={props.isLoading}
            headerText={getHeaderText(hasWinner, versionAIsWinning, isTied)}
            subheaderText={
                <PercentageText
                    comparisonMetricType={props.comparison.winningMetric}
                    hasWinner={hasWinner}
                    versionAStats={props.versionAStats}
                    versionBStats={props.versionBStats}
                    versionAIsWinning={versionAIsWinning}
                    isTied={isTied}
                />
            }
            percentComplete={props.comparison.percentComplete}
            minutesRemaining={props.comparison.minutesRemaining}
            hasWinner={hasWinner}
        />
    );
}
